import TimeAgo from 'javascript-time-ago'
import pt from 'javascript-time-ago/locale/pt.json'

let isInitialized = false

export const initTimeAgo = () => {
  if (!isInitialized) {
    TimeAgo.addLocale(pt)
    TimeAgo.setDefaultLocale('pt')
    isInitialized = true
  }
}
